export default __webpack_public_path__ + "cb3b9b65b09106fbd5d66c5158ee873b.svg";